import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "IRS_STATE_REJECTED/RECONCILIATION_RESUBMIT";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setPayerList: (state, action) => {
            state.payerList = action.payload;
        },

        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },

        setReconciliationResubmitGridData: (state, action) => {
            state.reconciliationResubmitGridData = action.payload;
        },

        setSelectedReconciliationResubmitGridData: (state, action) => {
            state.selectedReconciliationResubmitGridData = action.payload;
        },

        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
        setStateWitheldPaymentFrequency: (state, action) => {
            state.stateWitheldPaymentFrequency = action.payload;
        },
        setShowStateWitheldPaymentFrequencyPopup: (state, action) => {
            state.showStateWitheldPaymentFrequencyPopup = action.payload;
        },
        setCheckForStateFrequencyPopup: (state, action) => {
            state.checkForStateFrequencyPopup = action.payload;
        },
        setSelectedStateWitheldPaymentFrequency: (state, action) => {
            state.selectedStateWitheldPaymentFrequency = action.payload;
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },

        //Filters
        payerList: [],
        selectedPayer: { label: "", value: "" },

        //Grid
        reconciliationResubmitGridData: [],
        selectedReconciliationResubmitGridData: [],

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            SearchByTIN: "",
            SearchByName: "",
            IsDesc: true,
            Skip: 0,
            total: 10,
        },
        stateWitheldPaymentFrequency: {},
        showStateWitheldPaymentFrequencyPopup: false,
        checkForStateFrequencyPopup: false,
        selectedStateWitheldPaymentFrequency: "",
    }
})

export const { setLoadingState, setPayerList, setSelectedPayer, setReconciliationResubmitGridData, setSelectedReconciliationResubmitGridData, setPaginationState, setStateWitheldPaymentFrequency, setShowStateWitheldPaymentFrequencyPopup, setCheckForStateFrequencyPopup, setSelectedStateWitheldPaymentFrequency } = actions; 
